import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { State } from '../../app/store';
import { CHANGE_PASSWORD_CONFIRMATION, NEWSLETTER_CONFIRMATION } from "../../app/routes";

export default function useAddIdsToUrl() {
  const location = useLocation();
  const ids = useSelector((state: State) => state.config.facilityIds);

  const disabledRoutes = [NEWSLETTER_CONFIRMATION, CHANGE_PASSWORD_CONFIRMATION];

  useEffect(() => {
    if (!disabledRoutes.includes(location.pathname)) {
      if (ids !== "" && ids !== null) {
        const newSearch = `?id=${ids}`;
        const currentSearch = location.search;

        if (!currentSearch.includes(newSearch)) {
          window.history.pushState({}, "", `${location.pathname}${newSearch}`);
        }
      }
    }

    //eslint-disable-next-line
  }, [location]);
}

